import { RcClasses } from '../../../foundation';
export var RcPaperClasses = RcClasses([], 'RcPaper');
